module.exports = __webpack_public_path__ + "img/logo-main-full-white.5978f921.png";